module.exports = __webpack_public_path__ + "img/semaglutideOral_1.dc64b6dd.jpg";